import { readable } from 'svelte/store'
import { urlServeur } from '../components/conf.js'

 const parcxxx = readable([], async (set) => {
    const response = await fetch(urlServeur + "/api/immeubles/alldata")
    if (!response.ok) {

    }
    const res = await response.json()
    const data = await res.payload.immos
    //console.dir('Appt'+ data)
    set(data)
    return () => { };
});


/**
 *
 */
export const parc = readable(null,  function start(set) {
    fetch(urlServeur + "/api/immeubles/alldata")
        .then(function (response) {
            if (!response.ok) {
                throw new Error('unable to load immos on immostore init');
            }
            return response.json();
        })
        .then(function (data) {
            const immos = data.payload.immos;
            //console.log(immos)
            set(immos);
        });

    return function stop() {
        console.log('ImmoStore Stopped');
    };
});
